import ErrorPage from '@/components/error-page';
import SiteFooter from '@/components/site-footer';
import SiteHeader from '@/components/site-header';
import { buscarSessao } from '@/lib/auth';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/__authenticated')({
  component: RouteComponent,
  errorComponent: ({ reset }) => <ErrorPage reset={reset} />,
  beforeLoad: async ({ location }) => {
    const usuario = await buscarSessao();

    if (!usuario) {
      // A rota que ele tentou acessar viaja até o Autenticador no `state` e volta no
      // callback, então o login termina aqui e não no dashboard.
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }

    // O aluno (cliente final) só tem acesso a treinamentos no site novo, então é
    // mandado para lá a partir de qualquer outra rota a menos que não tenha a
    // permissão da rota.
    const rotasPermitidasClienteFinal = [
      '/suporte/treinamentos',
      '/sem-permissao',
    ];
    const emRotaPermitida = rotasPermitidasClienteFinal.some(rota =>
      location.pathname.startsWith(rota),
    );

    if (usuario.tipo === 'Customer' && !emRotaPermitida) {
      throw redirect({ to: '/suporte/treinamentos' });
    }
  },
});

function RouteComponent() {
  return (
    <>
      <SiteHeader />
      <Outlet />
      <SiteFooter />
    </>
  );
}
